// import axios from 'axios';
import axios_instance from "../services/axiosClient";

// Define the base URL for the API
const API_BASE_URL = process.env.REACT_APP_BASE_URL;

// Function to fetch all offers
export const getAllOffers = async () => {
  try {
    const response = await axios_instance.get(`${API_BASE_URL}/account/alerts/?alert_type=offers`);
    return response.data;
  } catch (error) {
    console.error('Error fetching product subcategories:', error);
    throw error;
  }
};

// Function to fetch all Top Ratings
export const getAllTopRatings = async () => {
  try {
    const response = await axios_instance.get(`${API_BASE_URL}/product/top_ratings/`);
    return response.data;
  } catch (error) {
    console.error('Error feching product subcategories:', error);
    throw error;
  }
}